<template>
    <div class="modal fade" :id="'updateParticipantModal' + _uid" role="dialog"
         aria-labelledby="updateParticipantModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updateParticipantModalLabel">{{$t('kendoGrid.infoModal.title')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>За да приложите комбинация, трябва да фокусирате грида.</p>
                    <p>Следните комбинации могат да се прилагат върху заглавните редове на колоните:</p>
                    <table>
                        <thead>
                        <tr>
                            <th align="left">КОМБИНАЦИЯ</th>
                            <th align="left">ОПИСАНИЕ</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td align="left">&nbsp;<code>Enter</code>&nbsp;</td>
                            <td align="left">Сортиране по колона.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Alt</code>+<code>Down</code>&nbsp;</td>
                            <td align="left">Отваря филтър менюто.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Esc</code>&nbsp;</td>
                            <td align="left">Затваря филтър менюто.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Tab</code>&nbsp;</td>
                            <td align="left">Скорлира измежду елементите на филтър менюто.
                            </td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Shift</code>+<code>Tab</code>
                            </td>
                            <td align="left">Същото като <code>Tab</code>, но в обратен ред.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Ctrl</code>+<code>Left Arrow</code>
                            </td>
                            <td align="left">Разменя местата на колоните с предишната.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Ctrl</code>+<code>Right Arrow</code>
                            </td>
                            <td align="left">Разменя местата на колоните със следващата.</td>
                            <hr>
                        </tr>
                        </tbody>
                    </table>
                    <p class="mt-3">Следните комбинации могат да се прилагат върху данните в грида:</p>
                    <table>
                        <thead>
                        <tr>
                            <th align="left">КОМБИНАЦИЯ</th>
                            <th align="left">ОПИСАНИЕ</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td align="left" class="mr-5">&nbsp;<code>Arrow Keys</code>&nbsp;</td>
                            <td align="left">Скролира между клетките.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Enter</code>&nbsp;</td>
                            <td align="left">Разширява/свива групира от редове.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Page Up</code>&nbsp;</td>
                            <td align="left">Връща към предишна страница.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Page Down</code>&nbsp;</td>
                            <td align="left">Отваря следваща страница.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Space</code>&nbsp;</td>
                            <td align="left">Избира реда, който държи подчертаната клетка.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Ctrl</code>+<code>Space</code>&nbsp;</td>
                            <td align="left">Селектира или не текущия ред, докато запазва предишните маркирани редове
                                (само за режим
                                множествен избор).
                            </td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Shift</code>+<code>Space</code>&nbsp;</td>
                            <td align="left">Представлява избор на диапазон. Избира всички редове между последния избран
                                (чрез <code>SPACE</code> или клик с мишка)
                                и този, който държи фокусираната клетка.
                            </td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Shift</code>+<code>Arrow Keys</code>&nbsp;</td>
                            <td align="left">Добавя реда, чиято клетка е маркирана, към селекцията (само за режим
                                множествен избор).
                            </td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Ctrl</code>+<code>Home</code>&nbsp;</td>
                            <td align="left">Фокусира последната фокусируема клетка в тялото на грида.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Ctrl</code>+<code>End</code>&nbsp;</td>
                            <td align="left">Фокусира последната фокусируема клетка на на последния ред.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>Home</code>&nbsp;</td>
                            <td align="left">Фокусира първата фокусируема клетка на реда.</td>
                            <hr>
                        </tr>
                        <tr>
                            <td align="left">&nbsp;<code>End</code>&nbsp;</td>
                            <td align="left">Фокусира последната фокусируема клетка на реда.</td>
                            <hr>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Absence} from "../../models/models";

    export default {
        name: "info.modal",
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onClose() {
                this.$emit('onClose');
            },
        },
        mounted() {
            //add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            //remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            },
        }
    }
</script>

<style scoped>
    td:nth-child(2) {
        padding-left: 20px;
    }
    th:nth-child(2) {
        padding-left: 30px;
    }
</style>
